import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';


import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import FixedToolbar from 'components/FixedToolbar'
import MainContentLayout from 'layouts/MainContentLayout';

import { observer } from 'mobx-react'
import { useRouterStore } from 'mobx-state-router';
import { useRootStore } from 'contexts';


import ActionButtons from 'jimbo/ui/ActionButtons'


import PromotionForm from './components/PromotionForm';

const useStyles = makeStyles((theme) =>
	createStyles({
		offset: theme.mixins.toolbar,
		backToOverview: {
			backgroundColor: theme.palette.primary.light
		}
	})
);


const PromationScreen = observer((props) => {

	const classes = useStyles();
    const routerStore = useRouterStore();
    const rootStore = useRootStore();
    const { promotionsStore } = rootStore;
	
	const promotion = promotionsStore.selectedObject;

    const onBackToOverview = () => {
		routerStore.goTo("promotions")
	}

    const backButton =  <Button
		onClick={() => onBackToOverview() }
		size="small"
		variant="text">
		<ArrowBackIcon />
			Back to Overview
		</Button>

	const toolbar = <FixedToolbar back={backButton} >
		<div>
			{promotion ? <ActionButtons store={promotionsStore} instance={promotion} />: null}
		</div>
	</FixedToolbar>


	return (
		<MainContentLayout toolbar={toolbar}>
			{promotion ?
			<Grid container>
				<Grid item xs={3}>
				</Grid>
				<Grid item xs={5}>
					<Box color="primary.main" bgcolor="background.paper" margin={1} padding={1}>
						<PromotionForm instance={promotion} store={promotionsStore} />
					</Box>
				</Grid>
			</Grid>: <div>no promotion</div>}

			<div className={classes.offset} />
		</MainContentLayout>)
});

export default PromationScreen;

